import React, { useContext } from 'react';
import { DeleteConfirmation, RouterContext } from '../../../../gs-component-right-rail';

interface Props {
  resetForm: () => void;
  submitForm: () => void;
  onClose: () => void;
  message: string;
}

const SaveConfirmation: React.FC<Props> = ({ resetForm, submitForm, onClose, message }) => {
  const { goBack } = useContext(RouterContext);

  return (
    <DeleteConfirmation
      onDelete={async (): Promise<void> => {
        await submitForm();
        resetForm();
        onClose();
      }}
      onCancel={goBack}
      info={message}
    />
  );
};

export default SaveConfirmation;
